<template>
  <!--<div>-->
  <div class="homeMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <!--<img  ref="homeBanner" src="../../../assets/img/homeBanner.jpg"/>-->

      <video muted width="100%" height autoplay loop>
        <source src="../../../assets/img/bannerVideo_1.mp4" type="video/mp4" />
        <!--您的浏览器不支持 video 标签-->
        <img ref="homeBanner" src="../../../assets/img/homeBanner.jpg" />
      </video>

      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <div class="contentW bannerText1">
          <!-- <img src="../../../assets/icon/logo3.png" /> -->
          <img src="../../../assets/icon/Banner Main@2x.png" />
        </div>
        <div class="contentW bannerText2">
          Expand your business scope and payment.
        </div>
        <div
          class="contentW bannerText3"
          style="overflow: visible;"
          @click="navClick('/contact')"
        >
          <span>CONTACT US</span>
        </div>
      </div>
    </div>
    <!--板块1-->
    <div class="index01" id="m1">
      <div
        class="contentW animated"
        :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"
        id="m1"
      >
        <div class="content_left_title">PAYMENT SOLUTIONS</div>
        <div class="tabsBox">
          <div class="tabsTitle">
            <span
              :class="act.tabsTitleId === 1 ? 'act' : ''"
              @click="tabsTitleClick(1)"
              >Instore</span
            >
            <span
              :class="act.tabsTitleId === 2 ? 'act' : ''"
              @click="tabsTitleClick(2)"
              >Online</span
            >
          </div>
          <div class="tabsContent">
            <ul v-if="act.tabsTitleId === 1">
              <li
                class="iconLi"
                @mouseenter="enter1(1, 1)"
                @mouseleave="leave1(1, 0)"
              >
                <div v-show="show.shows1 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore1.png" />
                  </div>
                  <div class="textDiv">Merchant QR Code</div>
                </div>
                <div
                  v-show="show.ids1 === 1 && show.shows1 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">Merchant QR Code</div>
                  <div class="textContent">
                    Customers can scan the static QR code to make a payment.
                    Customers are required to enter the price themselves.
                  </div>
                </div>
              </li>
              <li
                class="iconLi"
                @mouseenter="enter2(2, 1)"
                @mouseleave="leave2(2, 0)"
              >
                <div v-show="show.shows2 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore2.png" />
                  </div>
                  <div class="textDiv">Smart Device</div>
                </div>
                <div
                  v-show="show.ids2 === 2 && show.shows2 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">Smart Device</div>
                  <div class="textContent">
                    A smart device allows the merchant to create QR code for the
                    customer to scan or to scan the customer's payment code.
                  </div>
                </div>
              </li>
              <li
                class="iconLi"
                @mouseenter="enter3(3, 1)"
                @mouseleave="leave3(3, 0)"
              >
                <div v-show="show.shows3 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore3.png" />
                  </div>
                  <div class="textDiv">POS Integration</div>
                </div>
                <div
                  v-show="show.ids3 === 3 && show.shows3 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">POS Integration</div>
                  <div class="textContent">
                    We can integrate SuperiorPay with existing POS terminals.
                  </div>
                </div>
              </li>
              <li class="iconLi">
                <div class="borderDiv">
                  <div class="btnDiv" @click="navClick('/contact')">
                    CONTACT US
                  </div>
                </div>
              </li>
            </ul>
            <ul v-if="act.tabsTitleId === 2">
              <li
                class="iconLi"
                @mouseenter="enter1(1, 1)"
                @mouseleave="leave1(1, 0)"
              >
                <div v-show="show.shows1 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online1.png" />
                  </div>
                  <div class="textDiv">3rd Party Gateway</div>
                </div>
                <div
                  v-show="show.ids1 === 1 && show.shows1 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">3rd Party Gateway</div>
                  <div class="textContent">
                    Integrate Alipay and WeChat Pay with merchant’s website,
                    consumers can scan the QR code to make payments.
                  </div>
                </div>
              </li>
              <li
                class="iconLi"
                @mouseenter="enter2(2, 1)"
                @mouseleave="leave2(2, 0)"
              >
                <div v-show="show.shows2 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online2.png" />
                  </div>
                  <div class="textDiv">H5 Gateway</div>
                </div>
                <div
                  v-show="show.ids2 === 2 && show.shows2 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">H5 Gateway</div>
                  <div class="textContent">
                    Apply to mobile terminals, consumers pay on mobile websites
                    or Apps, and then switch to Alipay/WeChat Pay to finish
                    payments.
                  </div>
                </div>
              </li>
              <li
                class="iconLi"
                @mouseenter="enter3(3, 1)"
                @mouseleave="leave3(3, 0)"
              >
                <div v-show="show.shows3 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online3.png" />
                  </div>
                  <div class="textDiv">SDK Gateway</div>
                </div>
                <div
                  v-show="show.ids3 === 3 && show.shows3 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">SDK Gateway</div>
                  <div class="textContent">
                    Apply to mobile Apps, consumers can make payments in mobile
                    App.
                  </div>
                </div>
              </li>
              <li
                class="iconLi"
                @mouseenter="enter4(4, 1)"
                @mouseleave="leave4(4, 0)"
              >
                <div v-show="show.shows4 === 0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online4.png" />
                  </div>
                  <div class="textDiv">JSAPI Gateway</div>
                </div>
                <div
                  v-show="show.ids4 === 4 && show.shows4 === 1"
                  class="borderDiv border"
                >
                  <div class="textTitle">JSAPI Gateway</div>
                  <div class="textContent">
                    Apply to mini programs opened in Alipay/WeChat Pay,
                    consumers can finish payments with in the mini programs.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--板块2-->
    <div class="index02" id="m2">
      <div
        class="contentW animated"
        :class="animates.mm2 ? 'fadeInUp' : 'hideBox'"
      >
        <div class="content_center_title">DID YOU KNOW?</div>
        <div class="contentBox">
          <div class="text1">
            China is the largest and most valuable inbound visitor market for
            Australia. In the year ending September2018, short- term Chinese
            visitors made 13 million trips to the country and delivered $11.5
            billion to the Australia visitor economy.
          </div>
          <ul class="index02Ul">
            <li class="index02Li leftLi">
              <div class="div80">
                <div class="title">Chinese Payment Systems</div>
                <div class="content">
                  According to a recent survey by lpsos, Third-Party Mobile
                  Payment UsersResearch Report. It is estimated thatChina has
                  more than 940 million active mobile payment users.
                </div>
                <div class="btnDiv">
                  <div
                    class="btn1"
                    @click="linkDownload('/digial_sales_kit.pdf')"
                  >
                    Learn More
                  </div>
                  <div class="btn2" @click="navClick('/contact')">CONTACT US</div>
                </div>
              </div>
            </li>
            <li class="index02Li centerLi">
              <div class="div80">
                <div class="centerText">
                  Share of Transaction
                  <br />Value <br />by Payment Method
                </div>
              </div>
            </li>
            <li class="index02Li rightLi">
              <div class="div80">
                <div class="rowBox">
                  <img
                    src="../../../assets/icon/home_index2_icon1.png"
                  />Instore mobile payment-41%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon2.png" />Online
                  mobile payment-19%
                </div>
                <div class="rowBox">
                  <img
                    src="../../../assets/icon/home_index2_icon3.png"
                  />Instore card payment-16%
                </div>
                <div class="rowBox">
                  <img src="../../../assets/icon/home_index2_icon4.png" />Online
                  card payment-14%
                </div>
                <div class="rowBox">
                  <img
                    src="../../../assets/icon/home_index2_icon5.png"
                  />Others-16%
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--板块3-->
    <div class="index03" id="m3">
      <div
        class="contentW animated"
        :class="animates.mm3 ? 'fadeInUp' : 'hideBox'"
      >
        <div class="content_center_title">WHY SUPERIORPAY</div>
        <div class="contentBox">
          <ul>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon1.png" />
              </div>
              <div class="textDiv">Free sign-up at no extra charge</div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon2.png" />
              </div>
              <div class="textDiv">
                No Alipay or WeChat Payaccount required from merchants
              </div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon3.png" />
              </div>
              <div class="textDiv">'T+1' automatic settlement</div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon4.png" />
              </div>
              <div class="textDiv">No trading volume limit for merchants</div>
            </li>
          </ul>
          <ul>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon5.png" />
              </div>
              <div class="textDiv">Bank-grade financial security</div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon6.png" />
              </div>
              <div class="textDiv">
                Web + App accountmanagement, real-time account monitoring
              </div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon7.png" />
              </div>
              <div class="textDiv">Multi-platform marketing solutions</div>
            </li>
            <li>
              <div class="iconDiv">
                <img src="../../../assets/icon/home_index3_icon8.png" />
              </div>
              <div class="textDiv">24-hour customer services</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--板块 add2019-09-18-->
    <div class="index06" id="m4">
      <div
        class="contentW animated"
        :class="animates.mm4 ? 'fadeInUp' : 'hideBox'"
      >
        <div class="content_center_title">PARTNERS</div>
        <div class="contentBox">
          SuperiorPay wants to provide customers with a simple, convenient and
          customizable aggregation payment solution that enables customers to
          make payments at anytime, anywhere. SuperiorPay has integrated many
          mainstream payment methods, including but not limited to WeChat pay
          and Alipay.
        </div>
        <div class="btn" @click="navClick('/Partners')">Learn more</div>
        <ul class="logoUl">
          <li>
            <img
              src="../../../assets/icon/Citibank.png"
              width="153px"
              height="40px"
            />
          </li>
          <li>
            <img
              src="../../../assets/icon/unionpay.png"
              width="98px"
              height="61px"
            />
          </li>
          <li>
            <img
              src="../../../assets/icon/tenpay.png"
              width="152px"
              height="53px"
            />
          </li>
          <li>
            <img
              src="../../../assets/icon/antpay.png"
              width="134px"
              height="65px"
            />
          </li>
        </ul>
      </div>
    </div>
    <!--板块4-->
    <div class="index04" id="m4">
      <div
        class="contentW animated"
        :class="animates.mm4 ? 'fadeInUp' : 'hideBox'"
      >
        <div class="content_center_title">OUR CHANNELS</div>
        <div class="contentBox">
          SuperiorPay cooperates with Australia's local POS system providers,
          including Blueshyft, Futura, AuPos, IPOS,PosPal, and GVT,
          enabling system integration, settlement management, refund management
          etc., to ensure the customers have access to comprehensive cross-
          border payment services.
        </div>
        <div class="btn" @click="navClick('/contact')">CONTACT US</div>
        <ul class="logoUl">
          <li>
            <img src="../../../assets/icon/home_index4_icon1.png" />
          </li>
          <li>
            <img src="../../../assets/icon/home_index4_icon2.png" />
          </li>
          <li>
            <img src="../../../assets/icon/home_index4_icon3.png" />
          </li>
          <!-- <li>
            <img src="../../../assets/icon/home_index4_icon4.png" />
          </li> -->
          <li>
            <img src="../../../assets/icon/home_index4_icon5.png" />
          </li>
          <li>
            <img src="../../../assets/icon/home_index4_icon6.png" />
          </li>
        </ul>
      </div>
    </div>
    <!--板块5-->
    <div class="index05" id="m5">
      <div
        class="contentW animated"
        :class="animates.mm5 ? 'fadeInUp' : 'hideBox'"
        style="width: 1102px;"
      >
        <ul class="index5Ul">
          <li class="index5Li">
            <div class="mapBox">
              <img src="../../../assets/img/home_map_img1.png" />
            </div>
            <div class="mapTitle">Sydney Office</div>
            <div class="mapContent">
              Suite 2304
              <br />Level 23, 66 Goulburn St <br />Sydney NSW 2000
              <!-- <br />Phone:1300 066 006 -->
            </div>
          </li>
          <li class="index5Li">
            <div class="mapBox">
              <img src="../../../assets/img/home_map_img2.png" />
            </div>
            <div class="mapTitle">Melbourne Office</div>
            <div class="mapContent">
              201, Level 2B
              <br />818 Whitehorse Rd <br />Box Hill VIC 3128 
              <!-- <br />Phone: 1300 066 006 -->
            </div>
          </li>
          <li class="index5Li">
            <div class="mapBox">
              <img src="../../../assets/img/home_map_img3.png" />
            </div>
            <div class="mapTitle">Adelaide Office</div>
            <div class="mapContent">
              177 Gilbert street, Adelaide
              <br />SA 5000 
              <!-- <br />Phone: 1300 066 006 -->
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
</template>

<script>
import topNav from "./nav";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "home",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },

  data() {
    return {
      style: {
        bannerH: {
          height: "",
        },
      },
      act: {
        tabsTitleId: 1,
      },
      show: {
        ids1: 0,
        shows1: 0,
        ids2: 0,
        shows2: 0,
        ids3: 0,
        shows3: 0,
        ids4: 0,
        shows4: 0,
      },
      animates: {
        mm1: false,
        mm2: false,
        mm3: false,
        mm4: false,
        mm5: false,
        mm6: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    if (window.innerWidth > 1200) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.animates.mm1 = true;
      this.animates.mm2 = true;
      this.animates.mm3 = true;
      this.animates.mm4 = true;
      this.animates.mm5 = true;
    }
  },

  methods: {
    //  点击导航
    navClick(url) {
      this.$router.push(url);
    },

    //打开新连接
    linkDownload(url) {
      window.open(url, "_blank"); // 新窗口打开外链接
    },

    //鼠标滑动动画
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var offsetTop1 = document.querySelector("#m1").offsetTop;
      var offsetTop2 = document.querySelector("#m2").offsetTop;
      var offsetTop3 = document.querySelector("#m3").offsetTop;
      var offsetTop4 = document.querySelector("#m4").offsetTop;
      var offsetTop5 = document.querySelector("#m5").offsetTop;

      if (scrollTop > offsetTop1 - 700) {
        this.animates.mm1 = true;
      } else {
        this.animates.mm1 = false;
      }
      if (scrollTop > offsetTop2 - 700) {
        this.animates.mm2 = true;
      } else {
        this.animates.mm2 = false;
      }
      if (scrollTop > offsetTop3 - 700) {
        this.animates.mm3 = true;
      } else {
        this.animates.mm3 = false;
      }
      if (scrollTop > offsetTop4 - 700) {
        this.animates.mm4 = true;
      } else {
        this.animates.mm4 = false;
      }
      if (scrollTop > offsetTop5 - 700) {
        this.animates.mm5 = true;
      } else {
        this.animates.mm5 = false;
      }
    },

    //  tabs切换
    tabsTitleClick(index) {
      this.act.tabsTitleId = index;
    },

    //置顶
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    navClick2(url) {
      this.$router.push(url);
    },
    //  板块1鼠标移入移出
    enter1(id, show) {
      this.show.ids1 = id;
      this.show.shows1 = show;
    },
    leave1(id, show) {
      this.show.ids1 = id;
      this.show.shows1 = show;
    },
    enter2(id, show) {
      this.show.ids2 = id;
      this.show.shows2 = show;
    },
    leave2(id, show) {
      this.show.ids2 = id;
      this.show.shows2 = show;
    },
    enter3(id, show) {
      this.show.ids3 = id;
      this.show.shows3 = show;
    },
    leave3(id, show) {
      this.show.ids3 = id;
      this.show.shows3 = show;
    },
    enter4(id, show) {
      this.show.ids4 = id;
      this.show.shows4 = show;
    },
    leave4(id, show) {
      this.show.ids4 = id;
      this.show.shows4 = show;
    },
  },
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.homeMain {
  width: 100%;
  height: auto;
}
.homeMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.homeMain .bannerBox > img {
  width: 100%;
}
.homeMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.homeMain .bannerBox .topTextBox .bannerText1 {
  height: 7rem;
  text-align: center;
  margin-top: 16.5%;
}
.homeMain .bannerBox .topTextBox .bannerText1 > img {
  width: 14rem;
}
.homeMain .bannerBox .topTextBox .bannerText2 {
  font-size: 1.25rem;
  color: #fff;
  text-align: center;
  height: 22%;
  font-family: MontserratRegular;
}
.homeMain .bannerBox .topTextBox .bannerText3 {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  cursor: pointer;
}
.homeMain .bannerBox .topTextBox .bannerText3 > span {
  width: 150px;
  height: 56px;
  line-height: 56px;
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.6);
  font-family: MontserratMedium;
}
.homeMain .bannerBox .topTextBox .bannerText3 > span:hover {
  color: #fff;
  border: 1px solid #fff;
  transition: all 0.5s ease-in-out;
}

/*内容部分左侧标题*/
.content_left_title {
  font-size: 1.5rem;
  color: #4a4a4a;
  height: 5rem;
  line-height: 5rem;
  width: 100%;
  font-family: OpenSans600;
}
.content_center_title {
  font-size: 2.25rem;
  color: #4a4a4a;
  height: 5rem;
  line-height: 5rem;
  width: 100%;
  text-align: center;
  font-family: OpenSans300;
  font-weight: 300;
}

/*板块1*/
.index01 {
  height: auto;
  background-color: #fff;
  padding: 7rem 0;
}
.index01 .tabsBox {
  width: 100%;
  height: auto;
}
.index01 .tabsBox .tabsTitle {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #dbdbdb;
  font-family: MontserratMedium;
}
.index01 .tabsBox .tabsTitle > span {
  font-size: 1rem;
  color: #4a4a4a;
  padding: 0 0.7rem;
  display: inline-block;
  margin-right: 1rem;
  cursor: pointer;
}
.index01 .tabsBox .tabsTitle > span.act {
  border-bottom: 2px solid #f05423;
}
.index01 .tabsBox .tabsContent {
  width: 100%;
  height: 16rem;
}
.index01 .tabsBox .tabsContent > ul {
  width: 100%;
  height: 100%;
}
.index01 .tabsBox .tabsContent > ul .iconLi {
  width: 25%;
  height: 100%;
  float: left;
  cursor: pointer;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv {
  width: 80%;
  height: calc(100% - 2px);
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .iconDiv {
  width: 100%;
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 1rem;
  height: 6rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .iconDiv > img {
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .textDiv {
  width: 100%;
  text-align: center;
  font-size: 1rem;
  color: #4a4a4a;
  font-family: MontserratMedium;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .btnDiv {
  margin: 6.5rem auto;
  color: #fff;
  font-size: 0.97rem;
  background-color: #083358;
  font-family: MontserratMedium;
  width: 8rem;
  text-align: center;
  border-radius: 4px;
  height: 2.5rem;
  line-height: 2.5rem;
  cursor: pointer;
}

.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border {
  box-shadow: -2px 0 7px -1px #dadada, 0 -2px 0px -1px rgba(0, 0, 0, 0),
    0 2px 7px -1px #dadada, 2px 0 7px -1px #dadada;
  padding-top: 1rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border .textTitle {
  width: 10rem;
  margin: auto;
  font-family: MontserratMedium;
  font-size: 1rem;
  color: #4a4a4a;
  text-align: center;
  line-height: 3rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border .textContent {
  width: 10rem;
  margin: auto;
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #515151;
  text-align: center;
  line-height: 1.5rem;
}

/*板块2*/
.index02 {
  height: auto;
  background-color: #f6f6f6;
  padding: 4rem 0;
}
.index02 .contentBox {
  width: 100%;
  height: auto;
}
.index02 .contentBox .text1 {
  width: 43rem;
  font-size: 0.875rem;
  font-family: Montserrat300;
  color: #4a4a4a;
  text-align: center;
  margin: auto;
  line-height: 1.5rem;
  height: auto;
}
.index02 .contentBox .index02Ul {
  width: 100%;
  height: 17rem;
  margin-top: 5rem;
}
.index02 .contentBox .index02Ul .index02Li {
  float: left;
  width: 33.33%;
  height: 100%;
  overflow: hidden;
}
.index02 .contentBox .index02Ul .index02Li.leftLi {
}
.index02 .contentBox .index02Ul .index02Li.leftLi .div80 {
  width: 17rem;
  height: 100%;
  margin: auto;
}
.index02 .contentBox .index02Ul .index02Li.leftLi .title {
  font-size: 0.875rem;
  font-family: Montserrat600;
  color: #4a4a4a;
  text-align: center;
  line-height: 2.5rem;
}
.index02 .contentBox .index02Ul .index02Li.leftLi .content {
  font-size: 0.875rem;
  color: #4a4a4a;
  font-family: Montserrat300;
  text-align: center;
  line-height: 1.5rem;
  margin-top: 1rem;
}
.index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv {
  width: 100%;
  height: 2.5rem;
  margin-top: 2rem;
}
.index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn1 {
  font-family: MontserratMedium;
  width: 6.875rem;
  line-height: 2.5rem;
  text-align: center;
  font-size: 1rem;
  float: left;
  color: #4a4a4a;
  border: 1px solid #4a4a4a;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}
.index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn2 {
  font-family: MontserratMedium;
  width: 6.875rem;
  line-height: 2.5rem;
  text-align: center;
  font-size: 1rem;
  float: right;
  color: #fff;
  border: 1px solid #083358;
  background-color: #083358;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}
.index02 .contentBox .index02Ul .index02Li.centerLi .div80 {
  background: url("../../../assets/icon/home_index2_yuan.png") no-repeat center
    center;
  width: 17rem;
  height: 100%;
  display: flex;
  align-items: center;
  background-size: 100% 100%;
  margin: auto;
}
.index02 .contentBox .index02Ul .index02Li.centerLi .centerText {
  font-family: Montserrat300;
  width: 100%;
  height: 3.9rem;
  align-items: center;
  text-align: center;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.3rem;
}
.index02 .contentBox .index02Ul .index02Li.rightLi .div80 {
  width: 19rem;
  height: 100%;
  margin: auto;
}
.index02 .contentBox .index02Ul .index02Li.rightLi .rowBox {
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.index02 .contentBox .index02Ul .index02Li.rightLi .rowBox > img {
  margin-right: 1rem;
}

/*板块3*/
.index03 {
  height: auto;
  background-color: #fff;
  padding: 7rem 0;
}
.index03 .contentBox {
  width: 100%;
  height: 25rem;
}
.index03 .contentBox > ul {
  width: 100%;
  height: 50%;
}
.index03 .contentBox > ul > li {
  float: left;
  width: calc(25% - 10rem);
  height: calc(100% - 2rem);
  padding: 1rem 5rem;
}
.index03 .contentBox > ul > li .iconDiv {
  width: 100%;
  height: 6rem;
  text-align: center;
  margin-top: 1rem;
  display: flex;
  align-items: center;
}
.index03 .contentBox > ul > li .iconDiv > img {
  align-items: center;
  margin: auto;
}
.index03 .contentBox > ul > li .textDiv {
  width: 100%;
  font-size: 0.875rem;
  color: #6d7278;
  text-align: center;
  line-height: 1.3rem;
  font-family: MontserratMedium;
}

/*板块4*/
.index04 {
  height: auto;
  background-color: #181818;
  padding: 4rem 0;
}
.index04 .content_center_title {
  color: #fff;
}
.index04 .contentBox {
  width: 50%;
  margin: 2rem auto;
  color: #fff;
  font-size: 0.875rem;
  text-align: center;
  line-height: 1.5rem;
  font-family: Montserrat300;
}
.index04 .btn {
  width: 6.875rem;
  line-height: 2.5rem;
  margin: 4rem auto;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  text-align: center;
  font-family: MontserratMedium;
}
.index04 .btn:hover {
  color: #fff;
  border-color: #fff;
  transition: all 0.5s ease-in-out;
}
.index04 .logoUl {
  width: 100%;
  height: 4rem;
}
.index04 .logoUl > li {
  float: left;
  width: 16.66%;
  height: 100%;
  display: flex;
  align-items: center;
}
.index04 .logoUl > li > img {
  align-items: center;
  margin: auto;
}
/*板块add2019-09-18*/
.index06 {
  height: auto;
  background-color: #fafafa;
  padding: 4rem 0;
}
.index06 .content_center_title {
  color: #4a4a4a;
  font-family: OpenSans300;
  font-weight: 300;
  font-size: 3rem;
}
.index06 .contentBox {
  width: 50%;
  margin: 2rem auto;
  color: #4a4a4a;
  font-size: 0.875rem;
  text-align: center;
  line-height: 1.5rem;
  font-family: montserrat;
}
.index06 .btn {
  width: 6.875rem;
  line-height: 2.5rem;
  margin: 4rem auto;
  font-size: 0.875rem;
  color: #181818;
  cursor: pointer;
  border: 1px solid #181818;
  border-radius: 4px;
  text-align: center;
  font-family: PingFangRegular;
}
.index06 .btn:hover {
  color: #181818;
  border-color: #181818;
  transition: all 0.5s ease-in-out;
}
.index06 .logoUl {
  width: 100%;
  height: 4rem;
}
.index06 .logoUl > li {
  float: left;
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
}
.index06 .logoUl > li > img {
  align-items: center;
  margin: auto;
}

/*板块5*/
.index05 {
  height: auto;
  background-color: #f6f6f6;
  padding: 149px 0;
}
.index05 .index5Ul {
  width: 100%;
  height: 29rem;
}
.index05 .index5Ul .index5Li {
  width: 33.3%;
  height: 100%;
  float: left;
}
.index05 .index5Ul .index5Li .mapBox {
  width: 19rem;
  height: 19rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: auto;
}
.index05 .index5Ul .index5Li .mapBox > img {
  align-items: center;
  margin: auto;
}
.index05 .index5Ul .index5Li .mapTitle {
  width: 17rem;
  height: 3rem;
  line-height: 3rem;
  margin: auto;
  font-family: OpenSans600;
  text-align: center;
  font-size: 0.875rem;
  color: #515151;
}
.index05 .index5Ul .index5Li .mapContent {
  width: 13rem;
  height: auto;
  line-height: 1.5rem;
  margin: auto;
  font-family: Montserrat300;
  text-align: center;
  font-size: 0.875rem;
  color: #515151;
}

.hideBox {
  display: none;
}

@media screen and (max-width: 1600px) {
  .homeMain .bannerBox .topTextBox .bannerText2 {
    height: 15%;
  }
}

.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
.privacy_link{
  cursor: pointer;
  text-align: left;
  padding-left: -30px;
  /* float: left; */
}
</style>
